import React from 'react';
import { Box, Container, Flex, Separator } from '@magicpatterns/cubed';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ComplianceSection } from '../components/ComplianceSection';
import { SubprocessorsSection } from '../components/SubprocessorsSection';
import { LegalPrivacySection } from '../components/LegalPrivacySection';
import { Footer } from '../components/Footer';
export function TrustCenterPage() {
  return <Box className="bg-background min-h-screen w-full" data-id="element-81">
      <Navbar data-id="element-82" />
      <Container size="3" data-id="element-83">
        <Flex direction="column" gap="8" px="4" data-id="element-84">
          <HeroSection data-id="element-85" />
          <Separator size="4" data-id="element-86" />
          <ComplianceSection data-id="element-87" />
          <Separator size="4" data-id="element-88" />
          <SubprocessorsSection data-id="element-89" />
          <Separator size="4" data-id="element-90" />
          <LegalPrivacySection data-id="element-91" />
        </Flex>
      </Container>
      <Footer data-id="element-92" />
    </Box>;
}